import { GenericSetting } from '../../Types/portal';
import { post } from '../common';

const apiGenericSettingPath = 'api/genericsetting/';

export async function updateGenericSetting(setting: GenericSetting) {
	const path = `${apiGenericSettingPath}UpdateGenericSetting`;
	await post(path, setting);
}
